/**
 * @fileoverview gRPC-Web generated client stub for pb.v1alpha1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: v1alpha1/pipelines.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as v1alpha1_pipelines_pb from '../v1alpha1/pipelines_pb'; // proto import: "v1alpha1/pipelines.proto"


export class PipelinesServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListPipelines = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.PipelinesService/ListPipelines',
    grpcWeb.MethodType.UNARY,
    v1alpha1_pipelines_pb.ListPipelinesRequest,
    v1alpha1_pipelines_pb.ListPipelinesResponse,
    (request: v1alpha1_pipelines_pb.ListPipelinesRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_pipelines_pb.ListPipelinesResponse.deserializeBinary
  );

  listPipelines(
    request: v1alpha1_pipelines_pb.ListPipelinesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_pipelines_pb.ListPipelinesResponse>;

  listPipelines(
    request: v1alpha1_pipelines_pb.ListPipelinesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.ListPipelinesResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_pipelines_pb.ListPipelinesResponse>;

  listPipelines(
    request: v1alpha1_pipelines_pb.ListPipelinesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.ListPipelinesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.PipelinesService/ListPipelines',
        request,
        metadata || {},
        this.methodDescriptorListPipelines,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.PipelinesService/ListPipelines',
    request,
    metadata || {},
    this.methodDescriptorListPipelines);
  }

  methodDescriptorCreatePipeline = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.PipelinesService/CreatePipeline',
    grpcWeb.MethodType.UNARY,
    v1alpha1_pipelines_pb.CreatePipelineRequest,
    v1alpha1_pipelines_pb.Pipeline,
    (request: v1alpha1_pipelines_pb.CreatePipelineRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_pipelines_pb.Pipeline.deserializeBinary
  );

  createPipeline(
    request: v1alpha1_pipelines_pb.CreatePipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_pipelines_pb.Pipeline>;

  createPipeline(
    request: v1alpha1_pipelines_pb.CreatePipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void): grpcWeb.ClientReadableStream<v1alpha1_pipelines_pb.Pipeline>;

  createPipeline(
    request: v1alpha1_pipelines_pb.CreatePipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.PipelinesService/CreatePipeline',
        request,
        metadata || {},
        this.methodDescriptorCreatePipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.PipelinesService/CreatePipeline',
    request,
    metadata || {},
    this.methodDescriptorCreatePipeline);
  }

  methodDescriptorDeletePipeline = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.PipelinesService/DeletePipeline',
    grpcWeb.MethodType.UNARY,
    v1alpha1_pipelines_pb.DeletePipelineRequest,
    v1alpha1_pipelines_pb.DeletePipelineResponse,
    (request: v1alpha1_pipelines_pb.DeletePipelineRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_pipelines_pb.DeletePipelineResponse.deserializeBinary
  );

  deletePipeline(
    request: v1alpha1_pipelines_pb.DeletePipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_pipelines_pb.DeletePipelineResponse>;

  deletePipeline(
    request: v1alpha1_pipelines_pb.DeletePipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.DeletePipelineResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_pipelines_pb.DeletePipelineResponse>;

  deletePipeline(
    request: v1alpha1_pipelines_pb.DeletePipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.DeletePipelineResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.PipelinesService/DeletePipeline',
        request,
        metadata || {},
        this.methodDescriptorDeletePipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.PipelinesService/DeletePipeline',
    request,
    metadata || {},
    this.methodDescriptorDeletePipeline);
  }

  methodDescriptorGetPipeline = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.PipelinesService/GetPipeline',
    grpcWeb.MethodType.UNARY,
    v1alpha1_pipelines_pb.GetPipelineRequest,
    v1alpha1_pipelines_pb.Pipeline,
    (request: v1alpha1_pipelines_pb.GetPipelineRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_pipelines_pb.Pipeline.deserializeBinary
  );

  getPipeline(
    request: v1alpha1_pipelines_pb.GetPipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_pipelines_pb.Pipeline>;

  getPipeline(
    request: v1alpha1_pipelines_pb.GetPipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void): grpcWeb.ClientReadableStream<v1alpha1_pipelines_pb.Pipeline>;

  getPipeline(
    request: v1alpha1_pipelines_pb.GetPipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.PipelinesService/GetPipeline',
        request,
        metadata || {},
        this.methodDescriptorGetPipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.PipelinesService/GetPipeline',
    request,
    metadata || {},
    this.methodDescriptorGetPipeline);
  }

  methodDescriptorUpdatePipeline = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.PipelinesService/UpdatePipeline',
    grpcWeb.MethodType.UNARY,
    v1alpha1_pipelines_pb.UpdatePipelineRequest,
    v1alpha1_pipelines_pb.Pipeline,
    (request: v1alpha1_pipelines_pb.UpdatePipelineRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_pipelines_pb.Pipeline.deserializeBinary
  );

  updatePipeline(
    request: v1alpha1_pipelines_pb.UpdatePipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_pipelines_pb.Pipeline>;

  updatePipeline(
    request: v1alpha1_pipelines_pb.UpdatePipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void): grpcWeb.ClientReadableStream<v1alpha1_pipelines_pb.Pipeline>;

  updatePipeline(
    request: v1alpha1_pipelines_pb.UpdatePipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_pipelines_pb.Pipeline) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.PipelinesService/UpdatePipeline',
        request,
        metadata || {},
        this.methodDescriptorUpdatePipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.PipelinesService/UpdatePipeline',
    request,
    metadata || {},
    this.methodDescriptorUpdatePipeline);
  }

}

